import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combina clases de Tailwind resolviendo conflictos.
 * Convención estándar de shadcn/ui.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formato compacto de pesos colombianos para Radar, Expedientes y Admin.
 * Misma convención que la ficha municipal (`pages/ficha-municipal/_shared.ts`):
 * B (billón = 10^12), MM (mil millones = 10^9), M (millón), K (mil).
 * En español "B" es billón, así que 2.800 millones se lee "$2.80MM", nunca
 * "$2.8B" (issue #538). Acepta el Decimal serializado del backend ("2800000000.00").
 * Devuelve "—" si no hay monto y el crudo si no es numérico.
 */
export function formatCOP(raw: string | number | null | undefined): string {
  if (raw === null || raw === undefined || raw === "") return "—";
  const n = Number(raw);
  if (!Number.isFinite(n)) return String(raw);
  if (n >= 1e12) return `$${(n / 1e12).toFixed(1)}B`;
  if (n >= 1e9) return `$${(n / 1e9).toFixed(2)}MM`;
  if (n >= 1e6) return `$${(n / 1e6).toFixed(0)}M`;
  if (n >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toLocaleString("es-CO")}`;
}

/**
 * Formatea código DANE (5 dígitos, con separador).
 * Ej: "17486" → "17-486"
 */
export function formatDANE(code: string): string {
  if (code.length !== 5) return code;
  return `${code.slice(0, 2)}-${code.slice(2)}`;
}
